import {
    ApiHandler,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { AddCustomerApiParameter, createCustomer } from "@TKCCP/Services/tkccpCustomerRegistrationService";
import { NewCustomerModel } from "@TKCCP/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        apiParameter: AddCustomerApiParameter;
        onSuccess?: (refrenceNumber: string) => void;
        onError?: () => void;
    },
    AddCustomerApiParameter,
    NewCustomerModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.apiParameter;
};

export const SendDataToApi: HandlerType = async props => {
    const result = await createCustomer(props.apiParameter);
    if (result.status !== 200) {
        props.parameter.onError?.();
    } else {
        props.parameter.onSuccess?.(result.refrenceNumber);
    }
};

export const chain = [PopulateApiParameter, SendDataToApi];

const addCustomer = createHandlerChainRunner(chain, "AddCustomer");
export default addCustomer;
